import {Injectable} from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class CollaborationProtectionService {

	parseResourceName = (resourceObj) => {
		switch (resourceObj?.resource_type) {
			case 'chat':
				if (!resourceObj.name && resourceObj?.members?.length) {
					const membersCount = resourceObj.members.length + (resourceObj.external_members?.length || 0);
					resourceObj.name = `Chat (${membersCount} members)`;
				}
				break;

			case 'meeting':
				if (!resourceObj.name && resourceObj?.members?.length) {
					const membersCount = resourceObj.members.length + (resourceObj.external_members?.length || 0);
					resourceObj.name = `Meeting (${membersCount} members)`;
				}
				break;

			case 'drive':
				resourceObj.resource_type = 'OneDrive';
				break;
		}

		return resourceObj?.name;
	}

}
